export const BROWSER_OS_WINDOWS_PHONE = 'WINDOWS_PHONE';
export const BROWSER_OS_ANDROID = 'ANDROID';
export const BROWSER_OS_APPLE_MOBILE = 'APPLE_MOBILE';

export const daysOfWeek = [
  'MONDAY',
  'TUESDAY',
  'WEDNESDAY',
  'THURSDAY',
  'FRIDAY',
  'SATURDAY',
  'SUNDAY'
];

// Renault Mobility France companies
export const RMF_companies = {
  valid: '58107ebe-dc4c-403f-a54e-25271fd43da9',
  dev: 'fa16bdda-438d-4c12-8fd0-a306014edb35',
  staging: '58107ebe-dc4c-403f-a54e-25271fd43da9',
  prod: 'fb10f1b9-abb4-483a-a308-8afae9749d57'
};

// Ids to show legacy app in register popup unnShare mobilize belgium, colombia, brazil (prod)
//dev rci moilbity
//valid SHAREMOBILITY
//staging Airstone and 1 RRENT
export const showAppLegacy_companies = {
  dev: ['11b57833-cf3e-47c6-90bb-a01c8fe39353'],
  valid: ['34e4c790-2f80-43f4-8d42-01107ee0e7ef'],
  staging: [
    '84fc86db-385b-49dd-8baa-3ba65f7c2f0e',
    'bf5fee16-55d1-433f-9207-609a19f8e666'
  ],
  prod: [
    '9e285023-e1a6-43df-b02b-f27b724f23a3',
    'b46edfd3-9e1c-4f7b-925d-3ccbdafe8af7',
    '1240b6ae-851d-4d0d-bc1b-0a92017f398b'
  ]
};
